import makeStyles from "@mui/styles/makeStyles";
import { HEADER_ZINDEX } from "constants/styles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerWrapper: {
            display: "flex",
            backgroundColor: theme.palette.background.blue,
            height: 108,
            alignItems: "center",
            justifyContent: "space-between",
            padding: theme.spacing(2, 4),
            position: "sticky",
            zIndex: HEADER_ZINDEX,
        },
        title: {
            color: theme.palette.common.black,
        },
        bodyContainer: {
            padding: theme.spacing(2, 4),
        },
        subtitle: {
            color: theme.palette.secondary.main,
        },
        selectWrapper: {
            background: theme.palette.background.blue,
            padding: theme.spacing(2),
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4),
            borderRadius: 6,
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)",
        },
        selectAndTitle: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            minHeight: 80,
        },
        selectTitle: {
            fontWeight: 600,
            marginRight: theme.spacing(3),
        },
        permissionsWrapper: {
            paddingTop: theme.spacing(8),
        },
        autocompleteRoot: {
            width: "100%",
            "& .MuiOutlinedInput-root": {
                paddingRight: `${theme.spacing(2)} !important`,
            },
        },
        searchIcon: {
            width: "20px",
            height: "20px",
            marginRight: theme.spacing(1),
            marginLeft: theme.spacing(2),
        },
        circularProgress: {
            width: "20px !important",
            height: "20px !important",
        },
        companyResultsWrapper: {
            display: "flex",
            justifyContent: "space-between",
            padding: theme.spacing(1, 2),
            userSelect: "none",
            "& li:hover": {
                backgroundColor: "transparent",
            },
        },
        companyName: {
            alignContent: "center",
            fontWeight: 400,
            fontSize: "16px !important",
            userSelect: "none",
            marginLeft: theme.spacing(0.5),
        },
        companyLink: {
            color: theme.palette.secondary.main,
            letterSpacing: 1,
            textDecoration: "underline",
            fontSize: 12,
            marginLeft: theme.spacing(0.5),
        },
        divider: {
            width: "96%",
            height: "1px",
            backgroundColor: theme.palette.neutrals.light,
            justifyContent: "center",
            margin: "auto",
        },
        paper: {
            borderRadius: "30px",
            padding: theme.spacing(1),
        },
        linksWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            height: 46,
            margin: theme.spacing(1, 2.5),
        },
        crmContainer: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        shareIcon: {
            color: theme.palette.secondary.main,
            fontSize: 14,
            marginTop: theme.spacing(0.25),
        },
    })
);

export default useStyles;
